export default "__VITE_ASSET__QtT5z77y__"